import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "align-right fit-content" }
const _hoisted_4 = { class: "align-right" }
const _hoisted_5 = { class: "align-right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "align-center" }
const _hoisted_9 = { class: "fill noprint noselect" }

import { PropType } from 'vue'

import IfViewport from '@/components/common/IfViewport.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { RoundStandingsMatch } from '@/store/public/leagues.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueRoundMatchesTable',
  props: {
  rows: {
    type: Array as PropType<RoundStandingsMatch[]>,
    required: true,
  },
  roundId: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const leagues = useLeaguesStore()



return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (match, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `match-${i}`
          }, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(match.number) + ".", 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(match.home_team_name), 1),
            _createElementVNode("td", _hoisted_5, [
              (match.has_scores)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(match.home_team_points), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("td", { class: "align-center fit-content" }, "–", -1)),
            _createElementVNode("td", null, [
              (match.has_scores)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(match.away_team_points), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_8, _toDisplayString(match.away_team_name), 1),
            _createElementVNode("td", _hoisted_9, [
              (match.has_scores)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: {
                path: `/leagues/${_unref(leagues).selectedSeason}/${_unref(leagues).selectedLeague?.id}/standings/${__props.roundId}/${match.id}`,
              },
                    class: "standings-link"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("small", null, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "icon",
                          icon: "file-contract"
                        }),
                        _createVNode(IfViewport, { "min-width": "768" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('leagues.labels.standings')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})